export default __webpack_public_path__ + "static/favicon-378f9a835ce9d0a22c1fb40916d73653.ico";